{
  "close": "关闭",
  "notifications": "通知"
}
